export const mirrorPath = (arr, axis) => {
  switch (axis) {
    case 'x':
      return arr.map(item => [item[0], -item[1]])
    case 'y':
      return arr.map(item => [-item[0], item[1]])
    default:
      return console.log('Error, second Parameter must be an axis: "x" or "y"')
  }
}
